<template>
  <div class="home-reports">
    <Row :gutter="8">
      <Col style="margin-top: 8px">
        <Card shadow>
          <div style="text-align: center">
            查询月份：
            <DatePicker type="month"
                        size="small"
                        placement="bottom-end"
                        placeholder="起始月份"
                        v-model="afterValue"
                        @on-change="searchChangeStart"
                        :clearable="false"
                        style="width: 110px; padding-right: 5px"></DatePicker>
            <span> ~ </span>
            <DatePicker type="month"
                        size="small"
                        placement="bottom-end"
                        placeholder="截止月份"
                        v-model="beforeValue"
                        @on-change="searchChangeEnd"
                        :clearable="false"
                        style="width: 110px; padding-right: 5px"></DatePicker>
          </div>
        </Card>
      </Col>
      <Col :lg="24" style="margin-top: 8px">
        <Card shadow style="height: 200px">
          <p slot="title">
            <span>各平台消费（共 <span style="font-weight: bold">{{formatMoney(platformCost.total, '￥')}}</span>）</span>
          </p>
          <Spin fix v-show="platformCost.loading"></Spin>
          <Alert type="error" v-if="platformCost.error" show-icon>获取数据失败</Alert>
          <div id="bre_platform_cost_id" style="width: 100%; height: 150px;" v-else></div>
        </Card>
      </Col>
      <Col :lg="24" style="margin-top: 8px">
        <Card shadow style="height: 400px" title="各平台每月消费">
          <Spin fix v-show="monPlatformCost.loading"></Spin>
          <Alert type="error" v-if="monPlatformCost.error" show-icon>获取数据失败</Alert>
          <div id="bre_mon_platform_cost_id" style="width: 100%; height: 350px;" v-else></div>
        </Card>
      </Col>
      <Col :lg="24" style="margin-top: 8px">
        <Card shadow title="各平台账号消费">
          <Spin fix v-show="accountPlatformCost.loading"></Spin>
          <Alert type="error" v-if="accountPlatformCost.error" show-icon>获取数据失败</Alert>
          <Row :gutter="16">
            <Col :lg="6" v-for="(value, key, index) in accountPlatformCost.data" :key="`platformCost${index}`">
              <Card>
                <p slot="title">
                  <span :style="{color: platformColor[key]}">{{ key }}</span>
                </p>
                <p v-for="item in value.value" :key="item.username">
                  <Tooltip content="查看账号消费详情" placement="bottom" theme="light">
                    <a v-on:click="selectAccount(value.id, item.username)">{{ item.username }}</a>
                  </Tooltip>
                  <span style="float: right; font-weight: bold">{{ formatMoney(item.total, '￥') }}</span>
                </p>
              </Card>
            </Col>
          </Row>
        </Card>
      </Col>
      <Col :lg="24" style="margin-top: 8px" v-if="productCost.searchForm.platformAndUsername">
        <Card shadow style="height: 500px" class="no-padding-card-body">
          <p slot="title">
            <span>产品消费统计</span>
            <span style="float: left;">
              <Select size="small" style="width: 250px; padding-left: 5px; text-align: left"
                      clearable
                      v-model="productCost.searchForm.platformAndUsername"
                      @on-change="selectPlatformAndUsername"
                      placeholder="平台 & 账号">
                <OptionGroup :label="key" v-for="(value, key) in accountPlatformCost.data" :key="`optionGroup${value.id}`">
                  <Option v-for="item in value.value" :key="`${value.id}||${item.username}`" :value="`${value.id}||${item.username}`">{{ key }} | {{ item.username }}</Option>
                </OptionGroup>
              </Select>
            </span>
          </p>
          <div>
            <Alert type="error" v-if="productCost.error" show-icon style="margin: 16px;">获取数据失败</Alert>
            <Row :gutter="16" v-else>
              <Col :lg="14" style="margin-top: 8px">
                <div id="bre_mon_product_id" style="width: 100%; height: 450px;"></div>
              </Col>
              <Col :lg="10">
                <div id="pie_product_count_id" style="width: 100%; height: 450px;"></div>
              </Col>
            </Row>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getServerCostPlatform, getServerCostPlatformMon, getServerCostAccount, getServerCostProductMon,
  getServerCostProduct } from '@/api/opscenter'
import echarts from '@/view/monitor/components/echarts-use.js'
import { formatMoney, lastYearMonthRange } from '@/libs/tools'

let opt = {
  index: 0
}

let icon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAABDCAMAAABjnP3jAAAAilBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAQEAAAAAAAAAAAAAAAAAAAAAAAAAAADT09MAAAAAAAAAAAAAAAD////8/Pz5+fnr6+v8/Pzr6+vZ2dn09PTFxcX+/v719fX6+vrf39+5ubnDw8MSEhIrKytRUVF2dnZAQEDi4uLi4uLk5OTk5OT///+tdFIzAAAALXRSTlMABQgNFBwDNS4mCxEYIyAamisoMS364t9b57qWj3b0s6mec28rJhMNDKemZ2YvJtR9AAACMUlEQVRo3u2ZaW/iMBBAaTDdxI7tOCeF0vvaY/7/39sZJ2BgKyUrxNBKfh+RyHtMJkhJZl+Ja+LqzHjJ53rvTs5OX/Gp/n350DZwZu66h+X7vwmoT5YtMNEuE0w48n/cAiO3H0NB+P2cfioYZhDmD8yEs0ABydsNMHPzllDA4Jd/gJ3fEguGADm/B3bu5xIDhgGoFthpFY2gD5iLBthpxHwbIFUOFyBX8osE4ApYuAAWl4ACaAUuE0BLMAQs4AIsYkAMiAExIAbEgBgQA2JADIgB+wF3wE5zENABO+1+gF0BOytLAdt7ww2ws6F7w93d8Sv/M6LXg9tz8wzMPJsQQFuoH4GVR007uA2gEbz8AkZ+vtAAKMAXSBpB+dQBE91TSQOQ5N+NAAvSzapr4Mw03WqToj8MoN8CX+DSqvoxjQKOKCZ+sapS5/20AeFZsaQCozPn6jodpcLO4tiPH6aj1LVzmTbkl1d9QCgQmGC0zsYpHc6qOPDj73JlNo7WBvVi5w8FiU/IrV2MY2hWabHnT11GRx7H2tzrk+APBZiglJhATqerTIvgL2msuZiAUqgP/lBACYnEiAlgJu1sXQz+mrZK4JEnINFO+utT3prJfmczKiB/1m+V/I+3Zie+N8QGJazJ3Bpg7TJjhUL7ae8Np+Mr+wJdrtel7v3+2DMWqIGuGkG7SNsnaKtZ7McFIrc2F+z+UKAUXVfM/lDg/zr8Rc3tDwUefn9I8PDrQ4Jn9q35C4Ev35B0ZZBdAAAAAElFTkSuQmCC'

let platformColor = {}

export default {
  name: 'cost',
  data () {
    return {
      formatMoney: formatMoney,
      platformColor: platformColor,
      afterValue: '',
      beforeValue: '',
      after: '',
      before: '',
      platformCost: {
        total: 0,
        loading: false,
        error: false,
        barOption: {
          grid: {
            top: '2%',
            bottom: -15,
            right: 30,
            left: -30,
            containLabel: true
          },
          xAxis: {
            show: false
          },
          yAxis: [{
            triggerEvent: true,
            show: true,
            inverse: true,
            data: [],
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              color: '#666',
              align: 'left',
              margin: 100,
              fontSize: 13,
              formatter: function (value, index) {
                if (opt.index === 0 && index < 3) {
                  return '{idx' + index + '|' + (1 + index) + '} {title|' + value + '}'
                } else if (opt.index !== 0 && (index + opt.index) < 9) {
                  return '{idx|0' + (1 + index + opt.index) + '} {title|' + value + '}'
                } else {
                  return '{idx|' + (1 + index + opt.index) + '} {title|' + value + '}'
                }
              },
              rich: {
                idx0: {
                  color: '#FB375E',
                  backgroundColor: '#FFE8EC',
                  borderRadius: 100,
                  padding: [5, 8]
                },
                idx1: {
                  color: '#FF9023',
                  backgroundColor: '#FFEACF',
                  borderRadius: 100,
                  padding: [5, 8]
                },
                idx2: {
                  color: '#01B599',
                  backgroundColor: '#E1F7F3',
                  borderRadius: 100,
                  padding: [5, 8]
                },
                idx: {
                  color: '#333',
                  borderRadius: 100,
                  padding: [5, 8]
                },
                title: {
                  width: 165
                }
              }
            }
          }, {
            triggerEvent: true,
            show: true,
            inverse: true,
            data: [],
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              color: '#666',
              align: 'left',
              margin: 20,
              fontSize: 13,
              formatter: function (value, index) {
                return `总金额：${formatMoney(value, '￥')}`
              }
            }
          }],
          series: [{
            name: '',
            type: 'bar',
            yAxisIndex: 0,
            data: [],
            barWidth: 10,
            itemStyle: {
              normal: {
                color: (val) => {
                  let color = ['#FC619D', '#FF904D', '#48BFE3']
                  if (val.dataIndex < 3 && opt.index === 0) {
                    return color[val.dataIndex]
                  } else {
                    return '#1990FF'
                  }
                },
                barBorderRadius: 30
              }
            }
          }]
        }
      },
      monPlatformCost: {
        loading: false,
        error: false,
        barOption: {
          backgroundColor: '#fff',
          grid: {
            left: 100,
            top: '20%',
            bottom: 60,
            right: 0
          },
          legend: {
            data: [],
            align: 'left',
            right: 0,
            textStyle: {
              color: '#434e79',
              fontSize: 14,
              fontWeight: 400
            },
            itemWidth: 14,
            itemHeight: 14,
            itemGap: 35
          },
          tooltip: {
            trigger: 'axis',
            padding: [8, 10],
            backgroundColor: 'rgba(0,0,0,0.5)',
            axisPointer: {
              type: 'shadow',
              textStyle: {
                color: '#fff'
              }
            }
          },
          xAxis: [{
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#434e79',
                fontSize: 16,
                fontWeight: 400
              }
            }
          }],
          yAxis: [{
            min: 0,
            type: 'value',
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0
            },
            splitArea: {
              show: false
            }
          }],
          series: []
        }
      },
      accountPlatformCost: {
        loading: false,
        error: false,
        data: []
      },
      productCost: {
        searchForm: {
          platformAndUsername: '',
          support: null,
          username: null
        },
        loading: false,
        error: false,
        barOption: {
          backgroundColor: '#fff',
          grid: {
            left: 100,
            top: '20%',
            bottom: 60,
            right: 0
          },
          legend: {
            data: [],
            align: 'left',
            right: 0
            // textStyle: {
            //   color: '#434e79',
            //   fontSize: 14,
            //   fontWeight: 400
            // },
            // itemWidth: 14,
            // itemHeight: 10,
            // itemGap: 35
          },
          tooltip: {
            trigger: 'axis',
            padding: [8, 10],
            backgroundColor: 'rgba(0,0,0,0.5)',
            axisPointer: {
              type: 'shadow',
              textStyle: {
                color: '#fff'
              }
            }
          },
          xAxis: [{
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#434e79',
                fontSize: 16,
                fontWeight: 400
              }
            }
          }],
          yAxis: [{
            min: 0,
            type: 'value',
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0
            },
            splitArea: {
              show: false
            }
          }],
          series: []
        },
        pieOption: {
          title: {
            show: false
          },
          tooltip: {
            trigger: 'item',
            formatter: function (data, index) {
              let res = `<div class="circle_tooltip" style="background-color: ${data.color}"></div>` +
                `<span>${data.name}</span> : <span>${formatMoney(data.value, '￥')}</span>(${data.percent}%)<br/>`

              return res
            }
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: [],
            show: false
          },
          series: [
            {
              name: '产品',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              data: [],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              label: {
                normal: {
                  formatter: function (data, index) {
                    return `${data.name}：${formatMoney(data.value, '￥')}  {per|${data.percent}%}\n  `
                  },
                  rich: {
                    a: {
                      color: '#999',
                      lineHeight: 15,
                      align: 'center'
                    },
                    b: {
                      fontSize: 12
                    },
                    per: {
                      color: '#eee',
                      backgroundColor: '#334455',
                      padding: [2, 4],
                      borderRadius: 2
                    }
                  }
                }
              }
            }
          ]
        }
      }
    }
  },
  created: function () {
    this.initMonthRange()
    this.init()
  },
  methods: {
    init () {
      if (!this.after || !this.before) {
        return
      }
      this.getCostPlatformData()
      this.getCostProductData()
      this.getCostProductMonData()
    },
    initMonthRange () {
      let strRange = lastYearMonthRange()
      this.after = strRange[0]
      this.before = strRange[1]
      this.afterValue = strRange[0]
      this.beforeValue = strRange[1]
    },
    searchChangeStart (value) {
      this.after = value
      this.init()
    },
    searchChangeEnd (value) {
      this.before = value
      this.init()
    },
    getCostPlatformData () {
      let params = {
        start_date: this.after,
        end_date: this.before
      }
      this.platformCost.error = false
      this.platformCost.loading = true
      getServerCostPlatform(params).then(res => {
        let total = 0
        let colorR = ['#FC619D', '#FF904D', '#48BFE3', '#1990FF']
        for (let i in res.data.data) {
          if (colorR.length > i) {
            platformColor[res.data.data[i].registrar] = colorR[i]
          }
          total += parseFloat(res.data.data[i].total)
        }
        this.getCostMonPlatformData()
        this.getAccountPlatform()
        this.platformCost.total = total
        this.platformCost.barOption.yAxis[0].data = res.data.data.map(item => item.registrar)
        this.platformCost.barOption.yAxis[1].data = res.data.data.map(item => item.total)
        this.platformCost.barOption.series[0].data = res.data.data.map(item => {
          return {name: item.registrar, value: item.total}
        })
        let chart = echarts.init(document.getElementById('bre_platform_cost_id'), 'roma')
        window.addEventListener('resize', function () {
          chart.resize()
        })
        chart.clear()
        chart.setOption(this.platformCost.barOption, true)
        this.platformCost.loading = false
      }).catch(res => {
        this.platformCost.loading = false
        this.platformCost.error = true
        console.error(res)
      })
    },
    // 各平台每月消费
    getCostMonPlatformData () {
      let params = {
        start_date: this.after,
        end_date: this.before
      }
      this.monPlatformCost.error = false
      this.monPlatformCost.loading = true
      getServerCostPlatformMon(params).then(res => {
        this.monPlatformCost.barOption.xAxis[0].data = res.data.date_list
        let legend = []
        let series = []
        let ran = 50
        let total = []
        for (let i in res.data.total) {
          total.push(res.data.total[i])
        }
        for (let i in res.data.result) {
          legend.push(i)
          series.push({
            name: i,
            type: 'bar',
            stack: 'sum',
            barMaxWidth: 30,
            z: ran,
            itemStyle: {
              normal: {
                color: platformColor[i],
                label: {
                  show: false,
                  position: 'top',
                  distance: 0,
                  color: '#000',
                  fontSize: 16,
                  backgroundColor: {
                    image: icon
                  },
                  padding: [10, 15, 20, 15],
                  borderRadius: 100,
                  formatter: function (value, index) {
                    return value.seriesName + '：' + formatMoney(value.value, '￥')
                  }
                }
              }
            },
            data: res.data.result[i]
          })
          ran -= 1
        }
        series.push({
          name: '总金额',
          type: 'line',
          stack: '总量',
          symbolSize: 10,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: '#1bb8ee',
              barBorderRadius: 0,
              label: {
                show: true,
                position: 'top',
                formatter: function (p) {
                  return formatMoney(p.value, '￥')
                }
              }
            }
          },
          data: total
        })
        this.monPlatformCost.barOption.legend.data = legend
        this.monPlatformCost.barOption.series = series
        let chart = echarts.init(document.getElementById('bre_mon_platform_cost_id'), 'macarons')
        window.addEventListener('resize', function () {
          chart.resize()
        })
        chart.clear()
        chart.setOption(this.monPlatformCost.barOption, true)
        this.monPlatformCost.loading = false
      }).catch(res => {
        this.monPlatformCost.loading = false
        this.monPlatformCost.error = true
        console.error(res)
      })
    },
    // 每个平台各账号消费
    getAccountPlatform () {
      let params = {
        start_date: this.after,
        end_date: this.before
      }
      this.accountPlatformCost.loading = true
      this.accountPlatformCost.error = false
      getServerCostAccount(params).then(res => {
        this.accountPlatformCost.data = res.data.data
        this.accountPlatformCost.loading = false
      }).catch(res => {
        this.accountPlatformCost.loading = false
        this.accountPlatformCost.error = true
        console.error(res)
      })
    },
    // 按账号统计
    getCostProductData () {
      if (!this.productCost.searchForm.username || !this.productCost.searchForm.support || !this.after || !this.before) {
        return
      }
      let params = {
        username: this.productCost.searchForm.username,
        support: this.productCost.searchForm.support,
        start_date: this.after,
        end_date: this.before
      }
      this.productCost.loading = true
      this.productCost.error = false
      getServerCostProduct(params).then(res => {
        this.productCost.pieOption.legend.data = res.data.data.map(item => item.product_name)
        this.productCost.pieOption.series[0].data = res.data.data.map(item => {
          return {name: item.product_name, value: item.total}
        })
        let domainPlatformPie = echarts.init(document.getElementById('pie_product_count_id'), 'roma')
        window.addEventListener('resize', function () {
          domainPlatformPie.resize()
        })
        domainPlatformPie.clear()
        domainPlatformPie.setOption(this.productCost.pieOption, true)
        this.productCost.loading = false
      }).catch(res => {
        this.productCost.loading = false
        this.productCost.error = true
        console.error(res)
      })
    },
    selectPlatformAndUsername (value) {
      let username = ''
      let support = ''
      if (value) {
        support = value.split('||')[0]
        username = value.split('||')[1]
      }
      this.productCost.searchForm.username = username
      this.productCost.searchForm.support = support
      this.getCostProductData()
      this.getCostProductMonData()
    },
    selectAccount (support, username) {
      this.productCost.searchForm.platformAndUsername = `${support}||${username}`
      this.productCost.searchForm.username = username
      this.productCost.searchForm.support = support
      this.getCostProductData()
      this.getCostProductMonData()
    },
    // 产品每月消费
    getCostProductMonData () {
      if (!this.productCost.searchForm.username || !this.productCost.searchForm.support || !this.after || !this.before) {
        return
      }
      let params = {
        username: this.productCost.searchForm.username,
        support: this.productCost.searchForm.support,
        start_date: this.after,
        end_date: this.before
      }
      getServerCostProductMon(params).then(res => {
        this.productCost.barOption.xAxis[0].data = res.data.date_list
        let legend = []
        let series = []
        let ran = 50
        let total = []
        for (let i in res.data.total) {
          total.push(res.data.total[i])
        }
        for (let i in res.data.result) {
          legend.push(i)
          series.push({
            name: i,
            type: 'bar',
            stack: 'sum',
            barMaxWidth: 30,
            z: ran,
            itemStyle: {
              normal: {
                label: {
                  show: false,
                  position: 'top',
                  distance: 0,
                  color: '#000',
                  fontSize: 16,
                  backgroundColor: {
                    image: icon
                  },
                  padding: [10, 15, 20, 15],
                  borderRadius: 100,
                  formatter: function (value, index) {
                    return value.seriesName + '：' + formatMoney(value.value, '￥')
                  }
                }
              }
            },
            data: res.data.result[i]
          })
          ran -= 1
        }
        series.push({
          name: '总金额',
          type: 'line',
          stack: '总量',
          symbolSize: 10,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: '#1bb8ee',
              barBorderRadius: 0,
              label: {
                show: true,
                position: 'top',
                formatter: function (p) {
                  return formatMoney(p.value, '￥')
                }
              }
            }
          },
          data: total
        })
        this.productCost.barOption.legend.data = legend
        this.productCost.barOption.series = series
        let chart = echarts.init(document.getElementById('bre_mon_product_id'), 'roma')
        window.addEventListener('resize', function () {
          chart.resize()
        })
        chart.clear()
        chart.setOption(this.productCost.barOption, true)
      }).catch(res => {
        console.error(res)
      })
    }
  }
}
</script>

<style scoped>

</style>
